import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transfer'
})
export class TransferPipe implements PipeTransform {

  transform(transferInMB: number): string {
    if (transferInMB < 1024) return transferInMB.toString();
    return (Math.round(transferInMB / 1024 * 10) / 10).toString();
  }
}
